const { getElement } = window.BAO.Utils

class Variant {
  constructor (data, element) {
    this.data = data
    this.element = element
  }

  updateInput (closestButtons) {
    console.log('updateInput called')
    console.log('closestButtons:', closestButtons)
    if (!closestButtons) return

    const input = getElement('[data-article-variant-selects-external-el="id"]', { context: closestButtons })
    console.log('input:', input)
    if (!input) return

    input.value = this.id
    console.log('input value set to:', this.id)
    input.dispatchEvent(new Event('change', { bubbles: true }))
    console.log('change event dispatched')
  }

  get id () {
    return this.data ? this.data.id : undefined
  }
}

export class VariantOptions extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.collectedVariants = [new Variant(this.defaultVariant, this)]
  }

  setupListeners () {
    super.setupListeners()

    this.onVariantChange = this.onVariantChange.bind(this)

    this.listeners.add(this, 'change', this.onVariantChange)
  }

  onVariantChange (event) {
    const variant = this.getVariant()

    const closestButtons = event.target.closest('.prd-CardSimple_Buttons')
    variant.updateInput(closestButtons)
  }

  createVariant (data) {
    const variant = new Variant(data, this)
    this.collectedVariants.push(variant)

    return variant
  }

  getVariant () {
    if (!this.currentVariant) {
      return this.collectedVariants[0]
    }

    const existingVariant = this.collectedVariants.find(
      variant => variant.id === this?.currentVariant?.id,
    )
    if (existingVariant) return existingVariant

    return this.createVariant(this.currentVariant)
  }

  get defaultVariant () {
    return this.data[0]
  }

  get currentVariant () {
    return this.data.find(variant => {
      return variant.options.every(
        (option, index) => this.selectedOptions[index].value === option,
      )
    })
  }

  get data () {
    const innerText = this.els.data.element.innerText
    try {
      return innerText ? JSON.parse(innerText) : {}
    } catch (e) {
      console.error('Error parsing JSON:', e)
      return {}
    }
  }
}

export class VariantSelects extends VariantOptions {
  get selectedOptions () {
    return this.els.option.elements.map(el => {
      const { name } = el.dataset

      return {
        label: name,
        value: el.querySelector('select').value,
      }
    })
  }
}

if (!customElements.get('article-variant-selects')) {
  customElements.define('article-variant-selects', VariantSelects)
}
